import AppAlertBar from 'main/core/AppAlertBar';
import {notEmpty} from 'main/utility/CommonUtil';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hideAlert} from 'redux/actions';

const showMessageBar = (message) => {
  return <AppAlertBar type='success' message={message.toString()} />;
};

const showErrorBar = (error) => {
  return <AppAlertBar type='error' message={error.toString()} />;
};

const AppInfoView = () => {
  const dispatch = useDispatch();
  const {error, message} = useSelector(({commonReducer}) => commonReducer);

  useEffect(() => {
    if (message || error) {
      const timer = setTimeout(() => {
        dispatch(hideAlert());
      }, 3000); // Hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [message, error, dispatch]);

  return (
    <>
      {notEmpty(message) && showMessageBar(message)}
      {notEmpty(error) && showErrorBar(error)}
    </>
  );
};

export default AppInfoView;
